import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TdoUserGroupConfigurationModel} from '../../../../models/configuration/user/tdo-user-group-configuration.model';

@Component({
  selector: 'app-task-type-group-dialog',
  templateUrl: './task-type-group-dialog.component.html',
  styleUrls: ['./task-type-group-dialog.component.scss']
})
export class TaskTypeGroupDialogComponent implements OnInit {
  isLoading = true;

  groups: TdoUserGroupConfigurationModel[];
  selectedGroups: TdoUserGroupConfigurationModel[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) private data,
              private dialogRef: MatDialogRef<TaskTypeGroupDialogComponent>) { }

  ngOnInit(): void {
    this.groups = this.data.groups;
    this.isLoading = false;
  }

  onOkClick() {
    this.dialogRef.close(this.selectedGroups);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onCheckboxChange(event: MatCheckboxChange, group: TdoUserGroupConfigurationModel) {
    const sGroup = this.selectedGroups.find(p => p.UserGroupId === group.UserGroupId);
    const sGroupIdx = this.selectedGroups.findIndex(p => p.UserGroupId === group.UserGroupId);
    if (event.checked) {
      this.selectedGroups.push(group);
    } else {
      if (sGroup) {
        this.selectedGroups.splice(sGroupIdx, 1);
      }
    }
  }
}
